module.exports = __webpack_public_path__ + "static/media/image-green.3ccb81c1.svg";